<div class="grid-x">
    <div class="cell small-8"></div>
    <div class="cell small-4">
        <button class="button small margin-right" (click)="save()">SAVE</button>
        <button class="button small" (click)="cancel()">CANCEL</button>
    </div>
    <label class="cell small-12">
        Title
        <input type="text" [formControl]="form.controls.title" />
    </label>
    <label class="cell small-12">
        Latitude (Context Location)
        <input type="text" [formControl]="form.controls.latitude" />
    </label>
    <label class="cell small-12">
        Longitude (Context Location)
        <input type="text" [formControl]="form.controls.longitude" />
    </label>
    <label class="cell small-12">
        Buffer (Ft)
        <input type="text" [formControl]="form.controls.buffer" />
    </label>
    <span class="checkbox">
        <input class="show-for-sr no-margin-bottom" type="checkbox" id="geodesic" [formControl]="form.controls.geodesic">
        <label for="geodesic" class="inline">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            <span class="control-label-text">Geodesic</span>
        </label>
    </span>
</div>